
document.addEventListener('DOMContentLoaded', () => {
  const miniCart   = document.getElementById('mini-cart');
  const cartToggle = document.querySelector('.header__cart-toggle');
  if (!miniCart || !cartToggle) return;

  // 1) update the bubble count
  window.updateCartCount = () =>
    fetch('/cart.js')
      .then(r => r.json())
      .then(data => {
        const bubble = document.querySelector('#cart-icon-bubble .header__cart-count');
        if (bubble) bubble.innerText = data.item_count;
      })
      .catch(console.error);

  // 2) refresh the mini‑cart HTML
  window.updateMiniCart = () =>
    fetch(`/?sections=mini-cart&sections_url=${window.location.pathname}`)
      .then(r => r.json())
      .then(json => {
        const container = document.getElementById('mini-cart');
        if (container && json['mini-cart']) container.innerHTML = json['mini-cart'];
      })
      .catch(console.error);

  // 3) watch for any AJAX cart changes via data-item-count mutation
  new MutationObserver(mutations => {
    for (const m of mutations) {
      if (m.type === 'attributes' && m.attributeName === 'data-item-count') {
        updateCartCount();
        updateMiniCart();
        // if the drawer is closed, open it
        if (cartToggle.getAttribute('aria-expanded') === 'false') {
          cartToggle.click();
        }
        break;
      }
    }
  }).observe(miniCart, {
    attributes: true,
    attributeFilter: ['data-item-count']
  });

  // 4) wrap fetch to catch Shopify’s /cart/add.js and /cart/change.js calls
  const nativeFetch = window.fetch;
  window.fetch = (...args) =>
    nativeFetch(...args).then(response => {
      const url = typeof args[0] === 'string' ? args[0] : args[0].url;
      if (url.match(/\/cart\/(add|change)\.js$/)) {
        // after add or change, update UI
        response.clone().json().finally(() => {
          updateCartCount();
          updateMiniCart();
        });
      }
      return response;
    });
});
